"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WmsLayer = void 0;
var ste_simple_events_1 = require("ste-simple-events");
var Image_1 = require("ol/layer/Image");
var ImageWMS_1 = require("ol/source/ImageWMS");
var WmsLayer = /** @class */ (function () {
    function WmsLayer(group, _minZoom, _maxZoom, layerName, _queryable, styleName, urlParams) {
        if (_minZoom === void 0) { _minZoom = 0; }
        if (_maxZoom === void 0) { _maxZoom = 19; }
        if (urlParams === void 0) { urlParams = {}; }
        var _this = this;
        this.group = group;
        this._minZoom = _minZoom;
        this._maxZoom = _maxZoom;
        this.layerName = layerName;
        this._queryable = _queryable;
        this.styleName = styleName;
        this.urlParams = urlParams;
        //event - LayerLoading
        this._onLayerLoading = new ste_simple_events_1.SimpleEventDispatcher();
        //event - LayerLoaded
        this._onLayerLoaded = new ste_simple_events_1.SimpleEventDispatcher();
        this.setSource = function (map) {
            var cqlFilter;
            var defaultParams = {
                "LAYERS": _this.layerName
            };
            if (map.filters.CqlFilter !== null) {
                cqlFilter = map.filters.CqlFilter.getFilter(_this.group.filterOptions);
                if (cqlFilter) {
                    defaultParams["cql_filter"] = cqlFilter;
                }
            }
            if (_this.styleName) {
                defaultParams["STYLES"] = _this.styleName;
            }
            //merge the params
            var params = __assign(__assign({}, defaultParams), _this.urlParams);
            _this._wmsLayerSource = new ImageWMS_1.default({
                projection: map.getDisplayProjection(),
                url: _this.group.url,
                params: params,
                serverType: 'geoserver'
            });
            _this._wmsLayer = new Image_1.default({
                source: _this._wmsLayerSource
            });
            _this.addSourceHandlers(_this._wmsLayerSource);
        };
        this.updateStyleName = function (styleName) {
            _this.styleName = styleName;
            var params = _this._wmsLayerSource.getParams();
            if (_this.styleName) {
                params["STYLES"] = _this.styleName;
            }
            else {
                delete params["STYLES"];
            }
            _this._wmsLayerSource.updateParams(params);
            _this._wmsLayerSource.refresh();
        };
        this.addSourceHandlers = function (wmsLayerSource) {
            var self = _this;
            wmsLayerSource.on("imageloadstart", function () {
                self.onSourceLoading({ layer: self });
            });
            wmsLayerSource.on("imageloadend", function () {
                self.onSourceLoaded({
                    layer: self,
                    hasError: false
                });
            });
            wmsLayerSource.on("imageloaderror", function () {
                self.onSourceLoaded({
                    layer: self,
                    hasError: true
                });
            });
        };
        this.onSourceLoading = function (args) {
            _this._onLayerLoading.dispatch(args);
        };
        this.onSourceLoaded = function (args) {
            _this._onLayerLoaded.dispatch(args);
        };
        this.setInitialVisibility = function (mapZoom, store, visibleOnLoad) {
            _this._visible = (mapZoom >= _this._minZoom && mapZoom <= _this._maxZoom);
            if (_this._visible === true) {
                //layer is within zoom levels
                if (visibleOnLoad === true) {
                    _this._visible = true;
                    store.onLayerVisibiltyChanged(_this.group.ref, true);
                }
                else {
                    _this._visible = store.isLayerVisibile(_this.group.ref, _this.group.visibleOnFirstLoad);
                }
            }
            _this.setLayerVisibility(_this._visible);
        };
        this.setVisibility = function (mapZoom, store) {
            _this._visible = (mapZoom >= _this._minZoom && mapZoom <= _this._maxZoom);
            if (_this._visible === true) {
                //layer is within zoom levels
                _this._visible = store.isLayerVisibile(_this.group.ref, _this.group.visibleOnFirstLoad);
            }
            _this.setLayerVisibility(_this._visible);
        };
        this.setLayerVisibility = function (visible) {
            if (_this._wmsLayer) {
                _this._wmsLayer.setVisible(visible);
            }
        };
    }
    Object.defineProperty(WmsLayer.prototype, "onLayerLoading", {
        get: function () {
            return this._onLayerLoading.asEvent();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WmsLayer.prototype, "onLayerLoaded", {
        get: function () {
            return this._onLayerLoaded.asEvent();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WmsLayer.prototype, "visible", {
        get: function () {
            return this._visible;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WmsLayer.prototype, "minZoom", {
        get: function () {
            return this._minZoom;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WmsLayer.prototype, "maxZoom", {
        get: function () {
            return this._maxZoom;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WmsLayer.prototype, "olWmsLayer", {
        get: function () {
            return this._wmsLayer;
        },
        enumerable: false,
        configurable: true
    });
    return WmsLayer;
}());
exports.WmsLayer = WmsLayer;
//# sourceMappingURL=WmsLayer.js.map